import { jsx as _jsx } from "react/jsx-runtime";
import { AssistantMessageItem, UserMessageItem } from './items/MessageItem.js';
import { CompactionItem } from './items/CompactionItem.js';
import { ErrorItem } from './items/ErrorItem.js';
import { InteractionItem } from './items/InteractionItem.js';
import { ReasoningItem } from './items/ReasoningItem.js';
import { TodoItem } from './items/TodoItem.js';
import { ToolCallItem } from './items/ToolCallItem.js';
export function TimelineItemRenderer({ item, timestamp, messageGroup, renderMessageContent }) {
    switch (item.type) {
        case 'user_message': return _jsx(UserMessageItem, { item: item, timestamp: timestamp, messageGroup: messageGroup, content: renderMessageContent?.(item) });
        case 'assistant_message': return _jsx(AssistantMessageItem, { item: item, timestamp: timestamp, messageGroup: messageGroup, content: renderMessageContent?.(item) });
        case 'reasoning': return _jsx(ReasoningItem, { item: item });
        case 'tool_call': return _jsx(ToolCallItem, { item: item });
        case 'todo': return _jsx(TodoItem, { item: item });
        case 'interaction': return _jsx(InteractionItem, { item: item });
        case 'error': return _jsx(ErrorItem, { item: item });
        case 'compaction': return _jsx(CompactionItem, { item: item });
    }
}
//# sourceMappingURL=TimelineItemRenderer.js.map